// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cart: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 26">
            <path
                fill="currentColor"
                d="M4.062 0c.38 0 .709.263.793.632l.223.993h22.435c1.031 0 1.854 1.028 1.564 2.065l-2.742 9.752a1.626 1.626 0 0 1-1.564 1.183H8.034l.741 3.25h16.413c.446 0 .812.366.812.813a.815.815 0 0 1-.812.812H8.125a.814.814 0 0 1-.792-.635L3.414 1.625H.812A.812.812 0 1 1 .813 0h3.25ZM5.45 3.25 7.622 13h17.15l2.741-9.75H5.45ZM6.5 23.156a2.846 2.846 0 0 1 2.844-2.843 2.846 2.846 0 0 1 2.843 2.843A2.846 2.846 0 0 1 9.344 26 2.846 2.846 0 0 1 6.5 23.156Zm2.844 1.219c.675 0 1.218-.543 1.218-1.219 0-.675-.543-1.218-1.218-1.218-.676 0-1.219.543-1.219 1.218 0 .676.543 1.219 1.219 1.219ZM26 23.156A2.846 2.846 0 0 1 23.156 26a2.846 2.846 0 0 1-2.844-2.844 2.846 2.846 0 0 1 2.844-2.843A2.846 2.846 0 0 1 26 23.155Zm-2.844-1.218c-.675 0-1.219.543-1.219 1.218 0 .676.544 1.219 1.22 1.219.675 0 1.218-.543 1.218-1.219 0-.675-.543-1.218-1.219-1.218Z"
            />
        </svg>
    );
};

export default React.memo(Cart);
